import { GlassGrid, usePickGlassCats } from "@/features/glas/GlassGrid";

/** Homepage-sectie: een curated set glascategorieën (6 tegels — volledig, geen doorklik nodig). */
export function GlassCategories() {
  const cats = usePickGlassCats(["Enkel glas", "Isolatieglas", "Vacuümglas", "Veiligheidsglas", "Installatieglas", "Spiegels"]);
  return (
    <div className="mt-4 sm:mt-6">
      <GlassGrid cats={cats} cols={3} />
    </div>
  );
}
